import { Menu } from "@headlessui/react";
import type { ComponentPropsWithoutRef, ElementType } from "react";

export interface ItemProps {
  as?: ElementType;
  children: ComponentPropsWithoutRef<typeof Menu.Item>["children"];
  onClick?: () => void;
}

export const Item = ({ onClick, children, as }: ItemProps) => (
  <Menu.Item as={as} onClick={onClick}>
    {children}
  </Menu.Item>
);
